import { Include, Concept } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapConcepts = (data: any) => {
  if (!data) {
    return [];
  }

  return (
    data?.compose?.include
      ?.flatMap((include: Include) =>
        include.concept?.map((item: Concept) => ({
          value: item.code,
          label: item.display,
        }))
      )
      .filter(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (option: any): option is { value: string; label: string } =>
          option !== undefined
      ) || []
  );
};
